import AgendaGeneral from '../components/Agenda/AgendaGeneral';

const Dashboard = () => {
	return <AgendaGeneral />;
};

export default Dashboard;
